import { inject } from "@angular/core";
import { ResolveFn, Router } from "@angular/router";
import { ToastrService } from 'ngx-toastr'
import { UserDetailsService } from '../services/user-details.service';
import * as CryptoJS from 'crypto-js';
import * as localforage from 'localforage';

export const IpCheckResolver: ResolveFn<any> = async (
  _route,
  _state,
  userDetail = inject(UserDetailsService),
  router: Router = inject(Router),
  Toastrservice = inject(ToastrService)
) => {
    const val:any = await userDetail.getSelectedCompanyId();
    if(val){
      console.log(val);
      const companyId = CryptoJS.AES.decrypt(
          val?.trim(),
          ''
      ).toString(CryptoJS.enc.Utf8);
      console.log(companyId);

    }
    // if (val == 'true') {
    //     let params:any = _route.queryParams
    //     if(userDetail.userId === parseInt(params.user_id)){
    //         router.parseUrl('/unsubscribe');
    //     }else{
    //         Toastrservice.error('You are unauthorized')
    //         router.navigate(["/dashboard"])
    //     }
    // } else {
    //     Toastrservice.error('Please login to your account')
    //     router.navigate(["/"])
    // }
    return true
};